import page47 from "./Page47.webp";
import page48 from "./Page48.webp";
import page49 from "./Page49.webp";
import page50 from "./Page50.webp";
import page51 from "./Page51.webp";
import page52 from "./Page52.webp";
import page53 from "./Page53.webp";

export const warmPages = [
  page47,
  page48,
  page49,
  page50,
  page51,
  page52,
  page53,
];
